import { VendorContext } from "contexts/VendorContext";
import { useRef, useContext } from "react";
import globalVendorsStyles from "../../../Vendors.module.css";
import { useTranslation } from "react-i18next";

interface IProps {
  label: string;
  vendorKey: string;
  isNotes?: boolean;
  adjustheight?: () => void;
  limit?: number;
}

const VendorDetailItem = ({ label, vendorKey, isNotes, adjustheight, limit = 35 }: IProps) => {
  const { t } = useTranslation();
  const tBase = "views.vendors.VendorBody.VendorDetails.VendorDetailItem.VendorDetailItem";
  const tr = (key: string) => t(`${tBase}.${key}`);

  const { currentVendor } = useContext(VendorContext);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  if (!currentVendor) {
    return <div>{tr("No Vendor Found")}</div>;
  }

  const displayValue = currentVendor[vendorKey] ?? "";

  return (
    <div>
      <div style={{ fontWeight: "bold" }}>{label}</div>
      {isNotes ? (
        <textarea
          id="vendorTextArea"
          readOnly
          ref={textareaRef}
          value={displayValue}
          onInput={adjustheight}
          className={globalVendorsStyles.readonlyMode}
          maxLength={500}
          style={{ maxHeight: "305px" }}
        />
      ) : (
        <input
          readOnly
          maxLength={limit}
          value={displayValue}
          className={globalVendorsStyles.readonlyMode}
        />
      )}
    </div>
  );
};

export default VendorDetailItem;
